import actionTypes from '../constants/action-types';

const setSitesLimit = (limit) => ({
  type: actionTypes.SET_SITES_LIMIT,
  payload: limit,
});

export default setSitesLimit;
